import styled from 'styled-components'

interface ContainerProps {
  titleAlign?: 'start' | 'center'
  descriptionAlign?: 'start' | 'center'
  fancyTextBgColor?: string
  fancyText?: boolean
}

export const Container = styled.div<ContainerProps>`
  max-width: 32rem;
  display: flex;
  flex-direction: column;

  h2 {
    font-size: 3.5rem;
    margin-bottom: 1rem;
    width: 100%;
    text-align: ${(props) => props.titleAlign};
    background-color: transparent;
    font-size: ${({ fancyText }) => (fancyText ? '5.5rem' : '4rem')};
    font-family: ${({ fancyText }) =>
      fancyText ? 'Sacramento' : 'Gilroy Extra'};
    @media (max-width: 575.98px) {
      text-align: center;
    }
  }
  p {
    text-align: ${(props) => props.descriptionAlign};
    font-size: 1rem;
    color: var(--shape-color);
    letter-spacing: 1px;
    text-align: justify;
    @media (max-width: 575.98px) {
      text-align: center;
    }
  }
  a {
    text-decoration: none;
  }

  @media screen and (max-width: 500px) {
    h2 {
      font-size: 2rem;
    }
  }

  .fancy-text-container {
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    align-self: ${(props) =>
      props.titleAlign === 'start' ? 'flex-start' : 'center'};
  }

  .fancy-text-bg {
    position: absolute;
    background-color: ${({ fancyTextBgColor }) =>
      fancyTextBgColor ? fancyTextBgColor : '#f49e83'};
    height: 50%;
    border-radius: 2px;
    width: 95%;
    top: 1rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: -1;
  }
`

